import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import CoinList from '@/blocks/Price/PriceRec/CoinList'
import { useAdapter } from '@/components/Adapter'
import MarketList from '@/blocks/Price/PriceRec/MarketList'
import MarketRate from '@/blocks/Price/PriceRec/MarketRate'
import { Flex } from '@mantine/core'
import { Carousel, Indicator } from '@gate/gui'
import { PriceRecStyled, PriceRecGtXsStyled } from './style'

const PriceRec = () => {
  const { isMd } = useAdapter()
  const [activeIndex, setActiveIndex] = useState<number>(0)

  const handleIndicatorItemOnClick = (index: number) => {
    setActiveIndex(index)
  }

  const handleSwiperSlideOnChange = (index: number) => {
    setActiveIndex(index)
  }

  return (
    <PriceRecStyled>
      {isMd ? (
        <Flex gap={24}>
          <CoinList />
          <MarketList />
          <MarketRate />
        </Flex>
      ) : (
        <Flex direction="column" gap={24}>
          <MarketRate />
          <PriceRecGtXsStyled>
            <Carousel
              withControls={false}
              initialSlide={activeIndex}
              containScroll="trimSnaps"
              onSlideChange={handleSwiperSlideOnChange}
            >
              <Carousel.Slide style={{ width: '100%', marginRight: '16px' }}>
                <CoinList />
              </Carousel.Slide>

              <Carousel.Slide style={{ width: '100%' }}>
                <MarketList />
              </Carousel.Slide>
            </Carousel>
            <Indicator
              style={{
                position: 'absolute',
                bottom: '-14px',
                right: '50%',
                transform: 'translateX(50%)',
                zIndex: 1,
              }}
              active={activeIndex}
              itemOnClick={handleIndicatorItemOnClick}
              length={2}
            />
          </PriceRecGtXsStyled>
        </Flex>
      )}
    </PriceRecStyled>
  )
}

export default observer(PriceRec)
